import { render, staticRenderFns } from "./AlertTodoListModalComponent.vue?vue&type=template&id=54d4985d&"
import script from "./AlertTodoListModalComponent.vue?vue&type=script&lang=js&"
export * from "./AlertTodoListModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports